
import {
  defineComponent,
  onMounted,
  reactive,
  watch,
  ref,
  nextTick,
  toRefs,
  onBeforeUnmount
} from 'vue'
import LangSelect from '@/components/lang_select/Index.vue'
import { isValidUsername } from '@/utils/validate'
import { useRoute, LocationQuery, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { UserActionTypes } from '@/store/modules/user/action-types'
import Agreement from './Agreement.vue'
// import { useI18n } from 'vue-i18n'
import i18n from '@/locales/index'
import { ElMessage } from "element-plus";
import {getNowDate} from '@/utils/timeFormat'
import { chineseVerification } from '@/utils/validate'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { getCurrentInstance } from 'vue'
import {getAgreement} from '@/apis/home'
import { getLanguage } from "@/utils/cookies";
export default defineComponent({
  components: {
    LangSelect,
    Agreement
  },
  setup() {
    var instanceData:any
    const userNameRef = ref(null) // 企业号
    const passwordRef = ref(null)
    const loginFormRef = ref(null)
    const username = ref(null) // 账号
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    // const { t } = useI18n()

    const state = reactive({
      eyeFlag: true,
      eyeSrcHide: require('../../../assets/images/public/passWord-hide.png'),
      eyeSrcShow: require('../../../assets/images/public/passWord-show.png'),
      company_idFlag: true,
      loginForm: {
        username: '' as any,
        plaintext_password: '' as any,
        password: '' as any,
        company_id: '' as any,
        forgetPassword: false
      },
      loginRules: {
        company_id: [{ required: true, message: i18n.global.t('login.tip_company'), trigger: 'blur' }],
        username: [{ required: true, message: i18n.global.t('login.tip_username'), trigger: 'blur' }],
        password: [{ required: true, message: i18n.global.t('login.tip_pwd'), trigger: 'blur' }],
      },
      passwordType: 'password',
      loading: false,
      showDialog: false,
      capsTooltip: false,
      redirect: '',
      otherQuery: {},
      cacheObj: '' as any,
      dialogOpen: false,
      privacyCN: '',
      privacyEN: '',
      agreementCN: '',
      agreementEN: '',
      agrFlag: false,
      language: getLanguage()
    })

    const methods = reactive({
      validateUsername: (rule: any, value: string, callback: Function) => {
        if (!isValidUsername(value)) {
          callback(new Error('Please enter the correct user name'))
        } else {
          callback()
        }
      },
      validatePassword: (rule: any, value: string, callback: Function) => {
        if (value.length < 6) {
          callback(new Error('The password can not be less than 6 digits'))
        } else {
          callback()
        }
      },
      setlaguase(lang:string) {
           console.log(lang)
           store.dispatch(AppActionTypes.ACTION_SET_LANGUAGE, lang)
          //  console.log(locale)
           location.reload()
          //  locale.value = lang
          // reloads()
     },
      checkCapslock: (e: KeyboardEvent) => {
        const { key } = e
        state.capsTooltip =
          key !== null && key.length === 1 && key >= 'A' && key <= 'Z'
      },
      passwordInput(){
        state.loginForm.plaintext_password = chineseVerification(state.loginForm.plaintext_password)
      },
      showPwd: () => {
        state.eyeFlag = !state.eyeFlag
        if (state.eyeFlag) {
          state.passwordType = 'password'
        } else {
          state.passwordType = 'text'
        }
        nextTick(() => {
          (passwordRef.value as any).focus()
        })
      },
      dialogConfirm() {
        state.agrFlag = true
        state.dialogOpen = false
        methods.handleLogin()
      },
      handleClose(){
        state.dialogOpen = false
      },
      agreementConfirmation(){
        if(state.agrFlag){
          methods.handleLogin()
        }else{
          state.dialogOpen = true
        }
      },
      handleLogin: () => {
        (loginFormRef.value as any).validate(async (valid: boolean) => {
          if (valid) {
            state.loading = true
            state.loginForm.password = JSON.parse(JSON.stringify(state.loginForm.plaintext_password)) 

            // 解密
            if(state.loginForm.password.length > 20){
              state.loginForm.password = instanceData.proxy.$AES_Decrypt(state.loginForm.password)  
            }
            //加密
            state.loginForm.password = instanceData.proxy.$AES_Encrypt(state.loginForm.password)  
            let res =  await store.dispatch(UserActionTypes.ACTION_LOGIN, state.loginForm)
            // router
            //   .push({
            //     // path: state.redirect || '/robot/robotList',
            //     path: '/home/Homes',
            //     query: state.otherQuery
            //   })
            //   .catch(err => {
            //     console.warn(err)
            //   })
            // // 存用户信息和登录时间
            // let personalInfoObj = {
            //   company_id: state.loginForm.company_id,
            //   username: state.loginForm.username,
            //   loginTime: getNowDate()
            // }
            // localStorage.setItem('userInfo', JSON.stringify(personalInfoObj))
            // // Just to simulate the time of the request
            // // 记住密码 就存储账号 密码 企业号
            // if (state.loginForm.forgetPassword) {
            //   let obj = {
            //     cacheEnterprise: state.loginForm.company_id,
            //     cacheUser: state.loginForm.username,
            //     cachePassword: state.loginForm.password,
            //     forgetPasswordFlag: state.loginForm.forgetPassword
            //   }
            //   sessionStorage.setItem('cacheObj', JSON.stringify(obj))
            // } else {
            //   sessionStorage.setItem('cacheObj', '')

            // }
            setTimeout(() => {
              state.loading = false
            }, 0.5 * 1000)
          } else {
            return false
          }
        })
      }
    })

    function getOtherQuery(query: LocationQuery) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {} as LocationQuery)
    }

    watch(() => route.query, query => {
      if (query) {
        state.redirect = query.redirect?.toString() ?? ''
        state.otherQuery = getOtherQuery(query)
      }
    })

    onMounted(() => {
      getAgreement().then((res:any) => {
        console.log('res',res)
        res.data.forEach((item:string) => {
          let arr = item.split('_')
          if(arr.indexOf('privacy') != -1 && arr.indexOf('CN.html') != -1){
            state.privacyCN = item
          }else if(arr.indexOf('privacy') != -1 && arr.indexOf('EN.html') != -1){
            state.privacyEN = item
          }else if(arr.indexOf('agreement') != -1 && arr.indexOf('CN.html') != -1){
            state.agreementCN = item
          }else if(arr.indexOf('agreement') != -1 && arr.indexOf('EN.html') != -1){
            state.agreementEN = item
          }
        })
      })
      // 用户记住了密码就取缓存数据 直接赋值
      instanceData = getCurrentInstance()
      state.cacheObj = localStorage.getItem('cacheObj')
      if (state.cacheObj) {
        let cacheData = JSON.parse(state.cacheObj)
        state.loginForm.forgetPassword = cacheData.forgetPasswordFlag
        state.loginForm.company_id = cacheData.cacheEnterprise
        state.loginForm.plaintext_password = cacheData.cachePassword
        state.loginForm.username = cacheData.cacheUser
      }
      if(route.query.companyId){
          state.company_idFlag = false
          state.loginForm.company_id = route.query.companyId
        }

      if (state.loginForm.company_id === '') {
        (userNameRef.value as any).focus()
      } else if (state.loginForm.plaintext_password === '') {
        (passwordRef.value as any).focus()
      } else if (state.loginForm.username === '') {
        (username.value as any).focus()
      }
         document.getElementsByTagName('body')[0].style.overflowY = 'hidden'
    })
    onBeforeUnmount(()=>{
      document.getElementsByTagName('body')[0].style.overflowY = ''
    })
    return {
      userNameRef,
      passwordRef,
      loginFormRef,
      username,
      ...toRefs(state),
      ...toRefs(methods),
      route
      // t
    }
  }
})
